<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <!-- Sección Izquierda (Título) -->
                            <div class="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
                                <h6 class="mb-2 ms-2">Mis Proyectos</h6>
                            </div>
                            <div>
                                <input type="text" class="form-control me-4" placeholder="Buscar Proyecto..."
                                    v-model="searchQuery">
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered text-center align-middle">
                                <thead>
                                    <tr>
                                        <th>
                                            Identificador
                                        </th>
                                        <th>
                                            Cliente
                                        </th>
                                        <th>
                                            Proyecto
                                        </th>
                                        <th>
                                            Acciones
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="p in filteredProjects" :key="p.project_id">
                                        <td>{{ p.identifier }}</td>
                                        <td>{{ p.client }}</td>
                                        <td>{{ p.project_name }}</td>
                                        <td><button class="btn btn-warning mb-0"
                                                @click="goToProjectsUsers(p.project_id)">
                                                <i class="bi bi-people-fill"></i> Colaboradores</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const goToProjectsUsers = (id) => {
    router.push(`/project-users/${id}`)
}

const searchQuery = ref("")

const filteredProjects = computed(() => {
    const query = searchQuery.value.toLowerCase();
    return projects.value.filter(p =>
    (p.project_name?.toLowerCase().includes(query) || p.client?.toLowerCase().includes(query)
        || p.identifier?.toLowerCase().includes(query))
    );
});

import axios from 'axios';
const API_BASE_URL = process.env.VUE_APP_BASE_URL;
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage

const projects = ref([])

const fetchProjectsByPM = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-projects-by-pm`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        projects.value = response.data
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
};

onMounted(
    async () => {
        await fetchProjectsByPM()
    }
)

</script>